import React from "react";
import { getGlobalValue } from "@rea-argonaut/global-store";
var defaultContext = {
  portals: [],
  registerPortal: () => {},
  deregisterPortal: () => {}
};
export default getGlobalValue({
  key: "PortalContext",
  moduleName: "@rea-group/construct-kit-core",
  createValue: () => /*#__PURE__*/React.createContext(defaultContext)
});